import categories from '../../api/categories'
import * as types from '../mutation-types'

/**
 * Prevent multiple parallel requests from API.
 */
let categoriesPromise;

const state = {
    loading: false,
    categories: []
};

const getters = {

    categories: state => {
        return state.categories
    }

};

const actions = {

    getCategories({ commit }) {
        if (state.loading) {
            return categoriesPromise;
        } else {
            commit(types.LOADING);
            categoriesPromise = categories.get()
                .then(response => {
                    commit(types.GET_CATEGORIES, { categories: response.data });
                    commit(types.IDLE)
                    return response;
                }, response => {
                    commit(types.IDLE)
                    return response;
                })
                .catch(error => {
                    commit(types.IDLE)
                });

            return categoriesPromise;
        }
    },

};

const mutations = {

    [types.GET_CATEGORIES] (state, { categories }) {
        state.categories = categories
    },

    [types.LOADING] (state) {
        state.loading = true;
    },

    [types.IDLE] (state) {
        state.loading = false;
    }

};

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/categories.js